import {Component, Inject, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {StatePersistenceService} from '../../service/state.persistence.service';
import {BrowserStorageService} from '../../service/browser.storage.service';
import {CartDto, CartItemDto, ProductDto} from '../../@api';
import {BaseComponent} from '../component/base/base.component';
import {Router} from '@angular/router';
import {BreadcrumbService} from '../../service/breadcrumb.service';

export interface Record {
    products: ProductDto[]
}

export interface Customer {
    id?: number;
    name?: string;
    company?: string;
    date?: string | Date;
    status?: string;
    activity?: number;
    verified?: boolean;
    balance?: number;
}

@Component({
    template: ''
})
export abstract class AbstractQuote extends BaseComponent implements OnInit {

    data!: Record[];

    protected constructor(@Inject(DOCUMENT) public override document: Document,
                          protected state: StatePersistenceService,
                          protected browser: BrowserStorageService,
                          protected override router: Router,
                          protected override breadcrumbService: BreadcrumbService) {
        super(document, router, breadcrumbService);
        this.state.quoteComponent.data = this.browser.getLocalStorageValue('$q');
    }

    override ngOnInit(): void {
        super.ngOnInit();
    }

    addItemToQuote(product: ProductDto, qty: number): void {
        let cartItem: CartItemDto = {
            code: product.code,
            name: product.name,
            brand: product.brand,
            description: product.description,
            image: product.image,
            qty: qty
        };

        let cart: CartDto = this.browser.getLocalStorageValue('$q');
        if (!cart || !cart.items) {
            cart = this.newCartDto();
        }

        cart.items.push(cartItem);
        let expiryDate: Date = new Date();
        expiryDate.setDate(expiryDate.getDate() + 7);
        cart.expiryDate = expiryDate;

        this.browser.setLocalStorageValue('$q', cart);
        this.state.quoteComponent.data = cart;
    }

    newCartDto(): CartDto {
        let expiryDate: Date = new Date();
        expiryDate.setDate(expiryDate.getDate() + 7);
        return {
            items: [],
            expiryDate: expiryDate
        };
    }

    productUri(product: ProductDto): string {
        return String().concat(product.root);
    }

    categoryUri(product: ProductDto): string {
        const category: string = product.category.toLowerCase().replaceAll(' ', '-');
        return String('/').concat(category);
    }

    imageUri(product: ProductDto): string {
        const brand: string = product.brand.toLowerCase().replaceAll(' ', '-');
        return String().concat('https://www.solarcentral.co.za/images/', brand, '.png');
    }
}
